import { atom } from "jotai";

import { getDictTree } from "@/api/system/dictionaries";
import type { DictTreeItemVO } from "@/api/system/dictionaries/type";

/** 全量数据字典树（顶层为字典类型，children 为字典项） */
export const dictionariesAtom = atom<DictTreeItemVO[]>([]);

/** 字典是否已完成首次加载 */
export const dictReadyAtom = atom(false);

/**
 * 拉取并写入全量字典树
 * 字典配置页 CRUD 成功后也可 dispatch 此 atom 刷新
 */
export const refreshDictionariesAtom = atom(null, async (_get, set) => {
  try {
    const res = await getDictTree();
    set(dictionariesAtom, res.data);
  } catch {
    set(dictionariesAtom, []);
  } finally {
    set(dictReadyAtom, true);
  }
});
